import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AppConfig } from 'src/Services/app.config';
import { TrfaCategoryMasterService } from 'src/Services/trfa-category-master.service';
import { CheckAuth } from 'src/Services/utility.service';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-category-add-update',
  templateUrl: './category-add-update.component.html',
  styleUrls: ['./category-add-update.component.css']
})
export class CategoryAddUpdateComponent implements OnInit {

  categoryMasterForm: FormGroup;
  userID: any;
  appModel: any;
  SelectedTool: string;
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  tokenKey: any;
  isSubmit: boolean = false;
  isEdit: boolean = false;
  pattern = /^[ a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+(\s{0,1}[a-zA-Z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/? ])*$/

  constructor(private readonly _fb: FormBuilder,
    private readonly checkAuth: CheckAuth,
    private readonly activedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly trfaCategoryMaster: TrfaCategoryMasterService,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {

    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.userID = this.sessionStorageService.getAdminUserId();
    this.appModel = AppConfig.settings.ConnectionStrings;
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }
  ngOnInit() {
    this.isSubmit = false;
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.categoryMasterForm = this._fb.group({
      categoryId: 0,
      categoryName: ['', Validators.required],
      categorySort: ['', Validators.required],
    })
    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {
          this.isEdit = true;
          this.GetCategoryById(params['id']);
        }
      }
    });
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  cancelcategoryMaster() {
    let navigation = '/admin/' + this.SelectedTool + '/category';
    this.router.navigate([navigation]);
  }

  GetCategoryById(categoryId: number) {
    this.trfaCategoryMaster.GetCategoryById(this.tokenKey, parseInt(categoryId.toString())).subscribe(
      result => {
        if (result['status'] == 'Success') {
          this.categoryMasterForm.patchValue({
            categoryId: result['category'].categoryID,
            categoryName: result['category'].categoryName,
            categorySort: result['category'].categorySort
          });
        }
      });
  }

  save() {
    this.isSubmit = true;
    let data = this.categoryMasterForm.value;
    if (!this.categoryMasterForm.valid || !data.categoryName.trim())
      return
    let value = {
      categoryId: data.categoryId,
      categoryName: data.categoryName.trim(),
      categorySort: data.categorySort
    }
    this.trfaCategoryMaster.CategoryAddUpdate(this.tokenKey, value).subscribe(
      result => {
        if (result['status'] == 'Success') {
          if (result['message'] != "") {
            this.showMessage(result['message'], 'Warning', 'warning')
          } else {

            if (data.categoryId > 0)
              this.showMessage('category updated successfully', 'Success', 'success');
            else
              this.showMessage('category saved successfully', 'Success', 'success');
            this.router.navigate(['/admin/' + this.SelectedTool + '/category']);
          }
        }
        else {
          this.showMessage(result['status'], 'Error', 'error');
        }
      },
      error => {
        this.showMessage(error, 'Error', 'error');
      }
    );
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
    else if (msgType == 'warning') {
      setTimeout(() => this.toastr.warning(msg, msgTitle));
    }
  }
}
